import { Component, OnInit, ViewEncapsulation } from '@angular/core';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { MessageService } from 'src/app/core/services/message.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { SseNotificationService } from 'src/app/core/services/sse-notification.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  formulaireConnexion!: FormGroup;
  masquer = true;
  estConnecte : boolean = false;
  messageErreur : string | undefined;
  chargement: boolean = false;
  masquerMotDePasse: boolean = true;

  constructor(private fb: FormBuilder
    , private messageService: MessageService
    , private toastService: ToastService
    , private authService: AuthService
    , private router: Router
    , private sse: SseNotificationService) {}

  ngOnInit(): void {
    this.formulaireConnexion = this.fb.group({
      username: ['', [Validators.required]],
      password: [null, [Validators.required, Validators.minLength(4)]]
    });
  }

  connexion(){
    if (this.formulaireConnexion.invalid) {
      this.toastService.erreur(this.messageService.obtenirErreursValidationFormulaire(this.formulaireConnexion), 'Erreur de saisie du formulaire');
      return;
    } else {
      this.chargement = true;
      this.messageErreur = undefined;

      this.authService.connexion(this.formulaireConnexion.value).subscribe(reponse =>{
          this.authService.definirToken(reponse.token);
          this.authService.infosUtilisateur.userid = reponse.id;
          this.authService.connexionStatus.next(true);
          this.sse.demarrer();
          if (this.authService.urlRedirection != '') {
            this.router.navigate([this.authService.urlRedirection]);
          } else {
            this.messageErreur = undefined;
            this.chargement = true;
            this.router.navigate(['dashboard']);
          }
        },
        erreur => {
          if(erreur.status != "200") {
            this.messageErreur = erreur.message;
          } else if(erreur.status == "") {
            this.messageErreur = 'Erreur de communication avec le serveur. Veuillez contactez votre administrateur.';
          }
          this.chargement = false;
        })
    }
  }

  reinitialiser(){
    this.router.navigate(['resetpassword']);
  }

}
